<!-- <app-header></app-header> -->
<router-outlet></router-outlet>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>

<div id="attractions" class="nearby-places-section">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-cards-container">
    <div class="card unique-card">
      <img src="assets/images/Railway Station.jpg" class="card-img-top" alt="Railway station">
      <div class="card-body">
        <p class="card-text">Railway Station</p>
        <span class="text-muted">Distance From Hotel to Railway station <strong> 9.6 km (24 min)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Airport.jpg" class="card-img-top" alt="Airport">
      <div class="card-body">
        <p class="card-text">Biju Pattnaik International Airport </p>
        <span class="text-muted">Distance From Hotel to airport <strong> 12 km (28 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Busstop.jpg" class="card-img-top" alt="Bus Stop">
      <div class="card-body">
        <p class="card-text">Babasaheb Bhim Rao Ambedkar Bus Terminal </p>
        <span class="text-muted">Distance From Hotel to Babasaheb Bhim Rao Ambedkar Bus Terminal <strong> 13 km (24 min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Esplanade.jpg" class="card-img-top" alt="Esplanade Mall">
      <div class="card-body">
        <p class="card-text">Esplanade Mall</p>
        <span class="text-muted">Distance From Hotel to Esplanade Mall <strong> 5.3 km (14 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Symphony Mall.jpg" class="card-img-top" alt="Symphony Mall">
      <div class="card-body">
        <p class="card-text">Symphony Mall</p>
        <span class="text-muted">Distance From Hotel to Symphony Mall <strong> 2.0 km (6 min)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Rammandir.jpg" class="card-img-top" alt="Shri Ram Temple">
      <div class="card-body">
        <p class="card-text">Shri Ram Temple</p>
        <span class="text-muted">Distance From Hotel to Shri Ram Temple <strong> 8.1 km (19 min)</strong> </span>

      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Dhauli.webp" class="card-img-top" alt="Dhauligiri">
      <div class="card-body">
        <p class="card-text">Dhauli Shanti Stupa</p>
        <span class="text-muted">Distance From Hotel to Dhauli Shanti stupa <strong> 32 min (17 km)</strong> </span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Khandagiri.jpg" class="card-img-top" alt="Khandagiri and Udayagiri Caves">
      <div class="card-body">
        <p class="card-text">Khandagiri and Udayagiri Hills</p>
        <span class="text-muted">Distance From Hotel to Khandagiri and Udayagiri Hills <strong> 27 min (14 km)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Nadankanan.jpg" class="card-img-top" alt="Nadankanan">
      <div class="card-body">
        <p class="card-text">Nadankanan Zoological Park</p>
        <span class="text-muted">Distance From Hotel to Nadankanan Zoological Park <strong> 36 min (17 km)</strong></span>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Botanical Garden.jpg" class="card-img-top" alt="State Botanical Garden">
      <div class="card-body">
        <p class="card-text">State Botanical Garden</p>
        <span class="text-muted">Distance From Hotel to State Botanical Garden <strong> 39 min (18 km)</strong></span>
      </div>
    </div>
  </div>
</div>




<div class="gallery-container">
  <!-- Dynamic property images carousel in mobile view -->
  <div class="gallery-images-section">
    <h2>Our Gallery</h2>

    <!-- Carousel view for mobile devices -->
    <ngx-slick-carousel class="gallery-carousel" *ngIf="isMobileView" [config]="slideConfig">
      <div ngxSlickItem *ngFor="let image of property?.imageList" class="gallery-image-card">
        <img [src]="image.url" alt="Property Image">
      </div>
    </ngx-slick-carousel>

    <!-- Grid view for larger screens -->
    <!-- <div class="gallery-image-grid" *ngIf="!isMobileView">
      <div class="gallery-image-card" *ngFor="let image of property?.imageList">
        <img [src]="image.url" alt="Property Image">
      </div>
    </div> -->
    <div class="gallery-image-grid">
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/room11.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/room10.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/room8.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/room7.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/room4.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/hall1.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/hall2.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/hall3.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/hall4.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/hall5.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/hall6.jpg">
      </div>
      <div class="gallery-image-card">
        <img alt="Property Image" src="assets/images/Terrace.jpg">
      </div>
    </div>

  </div>
</div>








<div class="container my-5">
  <div class="row" id="testimonials">
    <!-- First Column -->
    <div class="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-start">
      <h2 class="headline font-weight-bold mb-3">Real Stays, Real Talk</h2>
      <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
      <a href="https://search.google.com/local/writereview?placeid=ChIJKYENfBILGToR3Z-g2zB8AHU "
        class="btn btn-primary btn-lg writereview">
        <div style="padding-left: 10px;padding-right: 10px; color: white;">
          Write a Review
        </div>
      </a>
    </div>

    <!-- Second Column (Carousel for Desktop) -->
    <!-- Second Column (Carousel for Desktop) -->
    <div class="col-md-8 mb-4 d-md-block">
      <div class="card shadow-sm border-0 h-100">
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner c-review-carousel" style="display: block;">
            <div class="carousel-item" data-interval="10000" *ngFor="let item of googleReviews; let i = index"
              [ngClass]="{ 'active': i === 0 }">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div class="c-review p-3">
                    <div style="text-align: center;">
                      <div>
                        <img src="assets/images/user.png" alt="{{ item.reviewerName }}"
                          class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" />
                      </div>
                      <div>
                        <h5 class="font-weight-bold mb-1">{{ item.reviewerName }}</h5>
                      </div>
                      <div>
                        <p class="small text-muted mb-2 c-review-text">{{ item.reviewText }}</p>
                      </div>
                      <div class="star-ratings text-warning">
                        {{ '★'.repeat(item.rating) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Carousel Controls Positioned Outside -->
        <div class="carousel-controls">
          <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>





  </div>
</div>






<div id="location" style="margin-bottom: 2px;">
  <div style="position: relative; width: 100%; max-width: 100%; height: 600px;">
    <!-- The iframe -->
    <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d123009.6778778237!2d73.74291459478502!3d15.535319609546052!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bbfc00fe1e409dd%3A0x65a9153f19fff85d!2sKadamba%20Depot%20Rd%2C%20Defence%20Colony%2C%20Porvorim%2C%20Salvador%20du%20Mundu%2C%20Goa%20403501!3m2!1d15.535334899999999!2d73.82531639999999!5e0!3m2!1sen!2sin!4v1735018691197!5m2!1sen!2sin" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d59864.464849105716!2d85.84380538413726!3d20.31975155610818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e0!4m0!4m5!1s0x3a190b127c0d8129%3A0x75007c30dba09fdd!2sTwilight%20Residency%2C%20Bharat%20Villa%20Road%2C%20Rudrapur%2C%20Bhubaneswar%2C%20Odisha!3m2!1d20.319699399999998!2d85.8851736!5e0!3m2!1sen!2sin!4v1744876076672!5m2!1sen!2sin"
      width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"></iframe>
    <div class="card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px;">
      <h3>Make Unforgettable Memories</h3>
      <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to
        us.</p>
      <button class="book-btn" (click)="navigate()">Book Your Stay</button>
      <p class="contact-footer">
        <i class="fa fa-phone"></i> {{property?.mobile}}
      </p>
      <p class="contact-footer">
        <i class="fa fa-envelope"></i> {{property?.email}}
      </p>

    </div>

  </div>
</div>
<!-- Dialogflow Messenger Integration -->

<df-messenger project-id="impactful-name-306810" agent-id="8bb6c52c-8667-4a24-a789-4cd78b154c96" intent="WEBSITE"
  storage-option="none" language-code="en" max-query-length="-1">
  <df-messenger-chat-bubble id="chatbot" chat-subtitle=""></df-messenger-chat-bubble>
</df-messenger>
<a [href]="getWhatsappShareUrl()" class="float" target="_blank">
  <i class="fa fa-whatsapp my-float"></i>
</a>

<app-footer></app-footer>
